import React, { useEffect, useState } from "react";

import "./style.scss";
import { Dialog, Notify } from "../../components";
import globalStore from "../globalStore";
import authStore from "../../stores/authStore";
import { Input } from "antd";
import { updateUserInfoApi } from "../../apis/index";

const SureInfoDialog = () => {
  const { dialog, setDialog } = globalStore();
  const { userInfo, updateUserInfo, changeUserInfoLocal } = authStore();

  const [userName, setUserName] = useState("");

  const updateInfo = async (validate?: boolean) => {
    if (validate && !userName) {
      Notify.error({
        message: "昵称不能为空",
        className: "notify-not-description",
        duration: 3,
      });
      return false;
    }
    await updateUserInfoApi({
      name: validate ? userName : userInfo.name,
    });
    // 更新
    await updateUserInfo();
    changeUserInfoLocal("isShowedModifyName", false);
  };

  const onCancel = async (validate?: boolean) => {
    await updateInfo(validate);
    setDialog("sure-info", false);
  };

  useEffect(() => {
    if (dialog["sure-info"]) {
      if (userInfo.name) {
        setUserName(userInfo.name);
      }
    }
  }, [dialog["sure-info"], userInfo]);

  return (
    <Dialog
      visible={dialog["sure-info"]}
      style={{ padding: 0, border: 0 }}
      onCancel={onCancel}
      layerClose={false}
      closeStyle={{
        top: "13px",
        right: "20px",
        width: "18px",
      }}
    >
      <div className="sure-info-dialog">
        <p className="p1">确认个人信息</p>
        <p className="p2">获取你的头像和昵称将用于平台展示</p>
        <div className="avatar">
          <img src={userInfo.avatar} alt="avatar" />
        </div>
        <Input
          value={userName}
          onChange={(e: React.BaseSyntheticEvent) => {
            setUserName(e.target.value);
          }}
        />
        <p className="p3">昵称作为平台唯一凭证，只能更改一次</p>
        <div className="btn" onClick={() => onCancel(true)}>
          提交
        </div>
      </div>
    </Dialog>
  );
};

export default SureInfoDialog;
